/* eslint-disable react-hooks/exhaustive-deps */
import { Drawer, Modal, notification } from "antd";
import React, { FC, useEffect, useState } from "react";
import style from "./style.module.scss";
import { DatePicker } from "antd";
import type { DatePickerProps } from "antd";
import "./style.scss";
import { DrawerType } from "../type";
import API from "../../../services/api.service";
import { APIS } from "../../../constants/apis";
import DayTypeLegend from "../../DayTypeLegend";
import {
  villaDayClass,
  villaDayIndex,
  DAY_TYPE_COLORS,
  EMPTY_VILLA_DAYS,
  VillaDayIndex,
} from "../../../utils/dayTypes";
import { useParams } from "react-router-dom";
import moment from "moment";
import { get } from "http";
const { RangePicker } = DatePicker;

const MaintenanceDayDrawer: FC<DrawerType> = ({
  showDrawer,
  setShowDrawer,
  visitData,
  readonly,
  title,
  onChange,
}) => {
  const param = useParams();
  const currDate = new Date().toLocaleDateString("en-CA");
  const [isReadOnly, setIsReadOnly] = useState(readonly || false);
  const [loading, setLoading] = useState(false);

  // Peak / high-peak days are global, not per-villa, so they load once.
  const [villaDays, setVillaDays] = useState<VillaDayIndex>(EMPTY_VILLA_DAYS);
  // const [showFeedBackFields, setShowFeedBackFields] = useState(
  //   visitData && currDate <= visitData.visit_date ? false : true
  // );
  const [visible, setVisible] = useState(false);
  // const [taskList, setTaskList] = useState([]);
  // const [selectedTask, setSelectedTask] = useState([]);
  // const [staffList, setStaffList] = useState([]);
  // const star_patern = [
  //   { name: "Very bad", img: "/images/property/star_icon.svg", id: 1 },
  //   { name: "Bad", img: "/images/property/star_icon.svg", id: 2 },
  //   { name: "Average", img: "/images/property/star_icon.svg", id: 3 },
  //   { name: "Good", img: "/images/property/star_icon.svg", id: 4 },
  //   { name: "Very good", img: "/images/property/star_icon.svg", id: 5 },
  // ];
  const defaultStatus = {
    date: true,
    staffrating: true,
    propertyrating: true,
    tasklist: true,
    stafflist: true,
    propertylist: true,
  };
  const [fieldStatus, setFieldStatus] = useState({ ...defaultStatus });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [blockedDates, setBlockedDates] = useState<any[]>([]);

  useEffect(() => {
    getBlockedDates();
  }, [showDrawer]);

  const getBlockedDates = async () => {
    try {
      setLoading(true);
      const res = await API.get(
        "/booking/booking-calendar-propertyid/" + param.id
      );

      if (res?.data?.data) {
        const booked = res.data.data.booked_date
          ? res.data.data.booked_date.map((d: any) => moment(d, "YYYY-MM-DD"))
          : [];

        const maintenance = res.data.data.maintenanceday_dates
          ? res.data.data.maintenanceday_dates.map((d: any) =>
              moment(d, "YYYY-MM-DD")
            )
          : [];
        setBlockedDates([...booked, ...maintenance]);
        // Same response already carries the villa's peak / high-peak days with
        // the long-weekend and 14-day rules applied.
        setVillaDays(villaDayIndex(res.data.data));
      }
      console.log("blocked", blockedDates);
    } catch (error) {
      console.error("Error fetching blocked dates:", error);
    } finally {
      setLoading(false);
    }
  };
  // const defaultState = Object.assign(
  //   {
  //     visit_date: "",
  //     completed_tasks: [],
  //     staff_rating: 0,
  //     staff_issue: [],
  //     property_rating: 0,
  //     property_issue: [],
  //     comment: "",
  //   },
  //   visitData,
  // )

  let defaultState = {
    visit_date: "",
    start_date: "",
    end_date: "",
    comment: "",
  };
  // defaultState = Object.assign(defaultState, visitData);

  const [data, setData] = useState({ ...defaultState, ...visitData });
  const onClose = () => {
    setShowDrawer(false);
    setVisible(false);
    if (visitData) {
      return;
    }
    onReset();
  };
  const showModal = () => {
    setIsModalVisible(true);
    setVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    setData({ ...data, ...visitData });
  }, [visitData]);

  useEffect(() => {
    setVisible(showDrawer);
    getConfig();
  }, [showDrawer]);

  const getConfig = async () => {
    const res = await API.get(APIS.USER_MANAGEMENT.CONFIG);

    // setTaskList(res.data.data.TASKS);
    // setStaffList(res.data.data.STAFF);
  };

  const removeTask = (value: any) => {
    let vals: any = [...data.completed_tasks];
    if (vals.includes(value)) {
      const index = vals.indexOf(value);
      if (index > -1) {
        vals.splice(index, 1);
      }
    }
    setData({ ...data, completed_tasks: vals });
  };

  const onResolve = async () => {
    if (!data.start_date || !data.end_date) {
      notification.error({
        message: `Please select a date range before adding`,
        placement: "top",
      });
      return;
    }
    const payload = {
      start_date: data.start_date,
      end_date: data.end_date,
      property_id: Number(param.id),
      remarks: data.comment,
    };

    try {
      const res = await API.post(
        APIS.USER_MANAGEMENT.ADD_MAINTENANCE_DAY,
        payload
      );

      if (res.data.status === 1) {
        setShowDrawer(false);
        setData(defaultState);
        showModal();
        onChange();
      } else {
        notification.error({
          message: res.data.message,
          placement: "top",
        });
      }
    } catch (error) {
      console.error("Error while adding maintenance day:", error);
      notification.error({
        message: `Something went wrong`,
        placement: "top",
      });
    }
    setFieldStatus(defaultStatus);
    onReset();
  };

  const onRangeChange = (dates: any, dateStrings: [string, string]) => {
    setData({
      ...data,
      start_date: dateStrings ? dateStrings[0] : "",
      end_date: dateStrings ? dateStrings[1] : "",
    });
    setFieldStatus({ ...fieldStatus, date: true });
  };

  const onReset = () => {
    // setData({ ...defaultState, visit_date: visitData.visit_date });
    // if (!readonly) setShowFeedBackFields(true);
    // setIsReadOnly(false);
    // setselectedDate("")
    if (readonly)
      setData({ ...defaultState, visit_date: visitData.visit_date });
    else {
      setData({ ...defaultState });
    }
    setFieldStatus({ ...defaultStatus });
  };

  return (
    <>
      <Drawer
        placement="right"
        onClose={onClose}
        maskClosable={true}
        closeIcon={
          <img
            className="icon-previous"
            src="/images/property/pending_icon.svg"
            alt="pending_logo"
          ></img>
        }
        closable={false}
        visible={visible}
        width={464}
        bodyStyle={{
          padding: 0,
          position: "relative",
          overflow: "scroll",
          height: "100%",
        }}
      >
        <div className={style.monthly_drawer}>
          <div className={style.monthly_header}>
            <div className={style.monthly_head_name}>
              {title || "Add monthly visit"}
            </div>
            <div className={style.closeBtn} onClick={onClose}>
              <img src="/images/close_icon.svg" alt="" />
            </div>
          </div>

          <div className={style.date}>Date</div>
          <div className={style.date_input}>
            {/* <RangePicker
              className={style.date_picker}
              onChange={(dates) => console.log("Selected range:", dates)}
              disabledDate={(current) => {
                if (!current) return false;
                if (current < moment().startOf("day")) return true;
                if (blockedDates.some((date) => current.isSame(date, "day")))
                  return true;
                return false;
              }}
              dateRender={(current) => {
                const isBlocked = blockedDates.some((date) =>
                  current.isSame(date, "day")
                );
                return (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      lineHeight: "24px",
                      background: isBlocked ? "#ffccc7" : undefined,
                    }}
                  >
                    {current.date()}
                  </div>
                );
              }}
            /> */}

            <DayTypeLegend showBooked={false} />
            <RangePicker
              value={
                data.start_date && data.end_date
                  ? [moment(data.start_date), moment(data.end_date)]
                  : null
              }
              className={style.date_picker}
              onChange={onRangeChange}
              disabled={isReadOnly}
              disabledDate={(current) => {
                if (loading) return true;
                // only past dates are un-selectable; already-blocked days can be
                // spanned (the backend skips them) and are shown shaded below.
                if (current && current < moment().startOf("day")) {
                  return true;
                }
                return false;
              }}
              dateRender={(current) => {
                const isBlocked = blockedDates.some((date) =>
                  current.isSame(date, "day")
                );
                const isPast = current < moment().startOf("day");
                // Colour the date itself, never the cell — same as the app
                // calendar and the other pickers. An already-blocked day reads
                // as maintenance; otherwise peak / high peak shows the admin
                // what a new block would land on.
                const special = villaDayClass(current, villaDays);
                const fg = isBlocked
                  ? DAY_TYPE_COLORS.maintenance
                  : special === "cell_high_peak"
                  ? DAY_TYPE_COLORS.high_peak
                  : special === "cell_peak"
                  ? DAY_TYPE_COLORS.peak
                  : isPast
                  ? "#999"
                  : undefined;
                return (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      lineHeight: "24px",
                      color: fg,
                      fontWeight: isBlocked || special ? 600 : undefined,
                      textDecoration: isBlocked ? "line-through" : undefined,
                    }}
                  >
                    {current.date()}
                  </div>
                );
              }}
            />
          </div>
          {!fieldStatus.date && (
            <div className={style.error}>Please select date</div>
          )}
          <>
            <div className={style.add_response}>Add a remark</div>
            <textarea
              value={data.comment}
              placeholder="Type here"
              className={style.textarea}
              onChange={(e) => {
                setData({ ...data, comment: e.target.value });
              }}
            ></textarea>
          </>
          <div className={style.buttongroup}>
            <button
              onClick={onReset}
              className={style.requestbuttons}
              style={{ marginRight: "25px" }}
            >
              Reset
            </button>
            <button
              onClick={onResolve}
              className={style.requestbuttons}
              style={{ background: "#082017", color: "white" }}
            >
              {visitData && visitData.id ? "Update" : "Add"}
            </button>
          </div>

          <div className={style.drawer_container}></div>
        </div>
      </Drawer>
      <Modal
        visible={isModalVisible}
        footer={null}
        onCancel={handleCancel}
        keyboard={true}
      >
        <div
          style={{
            height: "377px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <img src="/images/property/modal_success_icon.png" alt="" />
          <div className={style.modal_content} style={{}}>
            Your maintenance day request has been successfully submitted!
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MaintenanceDayDrawer;
